const { AllSeqObjectDimensions } = require('./allDimensionArrays');

module.exports = AllSeqObjectDimensions;
